import Vue from 'vue'
import Router from 'vue-router'
import Events from 'vue-events'
import VueTouch from 'vue-touch/dist/vue-touch.js'
import Translation from 'vue-multilanguage'

import $ from 'jquery'

import App from './app.vue'
import routes from './routes'
import VueMq from 'vue-mq'

import French from '../assets/translations/french.json'
import English from '../assets/translations/english.json'


Vue.use(Router)
Vue.use(VueTouch, {name: 'v-touch'})
let routing = new Router({
	mode: 'history',
	root: '/',
	routes: routes
})

VueTouch.config.swipe = {
  direction: 'horizontal'
}

Vue.use(Events)

Vue.use(Translation, {
	default: 'fr',
	fr: French,
	en: English
})

Vue.use(VueMq, {
	breakpoints: {
		mobile: 450,
		tablet: 900,
		desktop: Infinity,
	}
})

new Vue({
	el: '#app',
	router: routing,
	render: h => h(App)
});

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}


// WEBPACK FOOTER //
// ./src/main.js